import React from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import { Spacer } from 'design-system';
import ItemBadgeWrapper from './ItemBadgeWrapper';
import IconReceipt from './icons/toolbar/IconReceipt';
const ReceiptItemBadge = ({ handleClose, scrollY, onPress, isActiveKeyboard, scrollToItem }) => (<ItemBadgeWrapper scrollY={scrollY} handlePress={onPress} onCancel={handleClose} scrollToItem={scrollToItem} isActiveKeyboard={isActiveKeyboard}>
    <View style={styles.container}>
      <IconReceipt width={16} height={16} gradientKey="apricot"/>
      <Spacer w={4}/>
      <Text Text-14>Has receipt</Text>
    </View>
  </ItemBadgeWrapper>);
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
});
export default ReceiptItemBadge;
